import { render, staticRenderFns } from "./ChildBXLNew.vue?vue&type=template&id=d1c55b08&scoped=true&"
import script from "./ChildBXLNew.vue?vue&type=script&lang=js&"
export * from "./ChildBXLNew.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./ChildBXLNew.vue?vue&type=style&index=0&id=d1c55b08&prod&scoped=true&lang=css&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "d1c55b08",
  null
  ,true
)

export default component.exports